if (!customElements.get('standart-product')) {
  class StandartProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-product-form]');
      const variantsScript = this.querySelector('[data-variants]');
      if (!this.form || !variantsScript) return;

      this.variants = JSON.parse(variantsScript.textContent);
      this.variantInput = this.form.querySelector('[data-variant-input]');
      this.submitButton = this.form.querySelector('[data-submit-button]');
      this.submitText = this.form.querySelector('[data-submit-text]');
      this.errorMessage = this.form.querySelector('[data-error-message]');
      this.price = this.querySelector('[data-price]');
      this.compareAtPrice = this.querySelector('[data-compare-at-price]');
      this.saveBadge = this.querySelector('[data-save-badge]');
      this.slider = this.querySelector('[data-gallery-slider]');
      this.currentVariant = this.variants.find((variant) => String(variant.id) === this.variantInput.value);
      this.pendingSlideIndex = null;

      this.handleOptionChange = this.handleOptionChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleSwiperInit = this.handleSwiperInit.bind(this);

      this.form.addEventListener('change', this.handleOptionChange);
      this.form.addEventListener('submit', this.handleSubmit);
      this.slider?.addEventListener('swiper:init', this.handleSwiperInit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.handleOptionChange);
      this.form?.removeEventListener('submit', this.handleSubmit);
      this.slider?.removeEventListener('swiper:init', this.handleSwiperInit);
    }

    handleOptionChange(event) {
      if (!event.target.matches('[data-option-input]')) return;

      const selectedValues = Array.from(
        this.form.querySelectorAll('[data-option-input]:checked'),
        (input) => input.value
      );

      const previousVariant = this.currentVariant;
      this.currentVariant = this.variants.find((variant) =>
        variant.options.every((value, index) => value === selectedValues[index])
      );

      this.renderVariant(previousVariant);
    }

    renderVariant(previousVariant) {
      const variant = this.currentVariant;
      this.errorMessage.hidden = true;

      this.dispatchEvent(
        new CustomEvent('variant:changed', {
          bubbles: true,
          detail: { variant: variant || null, previousVariant: previousVariant || null },
        })
      );

      if (!variant) {
        this.setSubmitState(false, this.submitButton.dataset.unavailableText);
        return;
      }

      this.variantInput.value = variant.id;
      this.price.textContent = variant.price;
      this.compareAtPrice.textContent = variant.compareAtPrice;
      this.saveBadge.textContent = variant.saveBadge;
      this.setSubmitState(
        variant.available,
        variant.available ? this.submitButton.dataset.addToCartText : this.submitButton.dataset.soldOutText
      );
      this.goToMedia(variant.mediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    setSubmitState(isAvailable, text) {
      this.submitButton.disabled = !isAvailable;
      this.submitText.textContent = text;
    }

    goToMedia(mediaId) {
      if (!mediaId || !this.slider) return;

      const slides = Array.from(this.slider.querySelectorAll('[data-media-id]'));
      const slideIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (slideIndex === -1) return;

      if (this.slider.swiper) {
        this.slider.swiper.slideTo(slideIndex);
        return;
      }

      this.pendingSlideIndex = slideIndex;
    }

    handleSwiperInit(event) {
      if (this.pendingSlideIndex === null) return;

      event.detail.swiper.slideTo(this.pendingSlideIndex, 0);
      this.pendingSlideIndex = null;
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (!this.currentVariant?.available || this.submitButton.getAttribute('aria-busy') === 'true') return;

      this.submitButton.disabled = true;
      this.submitButton.setAttribute('aria-busy', 'true');
      this.errorMessage.hidden = true;
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      try {
        const response = await fetch(`${window.routes.cartAddUrl}.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new FormData(this.form),
        });
        const result = await response.json();

        if (!response.ok) {
          this.showError(result.description || result.message);
          return;
        }

        this.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: this.currentVariant, quantity: 1 },
          })
        );
      } catch (error) {
        console.error(error);
      } finally {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        this.submitButton.removeAttribute('aria-busy');
        this.submitButton.disabled = !this.currentVariant?.available;
      }
    }

    showError(message) {
      if (!message) return;

      this.errorMessage.textContent = message;
      this.errorMessage.hidden = false;
    }
  }

  customElements.define('standart-product', StandartProduct);
}
